export const Dashboard = `
The Dashboard is a space for you to see an overview of everything in your trainer portal. You will be able to see what work needs to be completed.
`

export const Channel = `
Your Channel is your space to share your workouts and message with fans and clients. The information you write and upload here will be displayed in the Strivers app on your personal channel.
`;

export const ChannelFAQ = [{
  "question": "I don't have a bio video? Where do I get one?",
  "answer": "If you have not received a bio video yet you will get one don't worry. Our production team is working on it.",
}, {
  "question": "I don't have the pictures or content from the shoot yet.",
  "answer": "The pictures and content from the shoot will be uploaded soon. We haven't forgotten.",
}];

export const Exercise = `
You can find all the exercises you have completed in your exercise library. Use the filter buttons below search to narrow your results.
`;

export const ExerciseFAQ = [{
  "question": "How do I add a new exercise I don't have in my library?",
  "answer": "Click the add exercise button in the top right corner of the screen. Name the exercise and hit submit.",
}, {
  "question": "How do I find exercises with missing muscle groups or equipment?",
  "answer": "Click on the muscle groups filter. Look for the button that says none and select it. Click see results.",
}];

export const ExerciseDemo = `
You can find all the videos of exercise demonstrations you have uploaded here. If you want to add new exercises to your library you can take use your phone or camera to take a video of yourself doing the exercise then upload it here.
`;

export const ExerciseDemoTextList = [{
  "heading": "What is an exercise demonstration video?",
  "text": "This is a video displayed in the app to show fans and clients the correct exercise form. THIS IS NOT a full length video of you doing the exercise for 60 seconds. It is just a demonstration. The exercise demonstration repeats on a continuous loop with a timer or reps in the app. We ask trainers to do 4-6 reps of the exercise."
}, {
  "heading": "How to record an exercise demonstration video?",
}, {
  "heading": "Step 1",
  "text": "If you are using your phone turn it to landscape view. Videos taken in portrait view will not work with our app format.",
  "image": "portrait_vs_landscape.jpg"
}, {
  "heading": "Step 2",
  "text": "Put your phone or camera on a tripod. You do not want to hold the phone or camera because that causes shaking in the video loop.",
  "image": "tripod.jpg"
}, {
  "heading": "Step 3",
  "text": "Record 4-6 reps of you doing the exercise."
}, {
  "heading": "Step 4",
  "text": "Trim the video. You want to make sure your body placement for the exercise demonstration starts and stops in the same spot. You do NOT want to have video where you are walking back to the camera to pause it or looking away."
}, {
  "heading": "Tip",
  "text": [
    "Trim the video right as you start and end. You want to get as close to the same position you.",
    "Good lighting is key. Make sure there is adequate lighting in the room.",
    "Check to see if you are properly framed in the camera. You do not want to be too far away."
  ],
  "image": "trainer_position.jpg"
}];

export const ExerciseDemoFAQ = [{
  "question": "Do I talk in the video?",
  "answer": "No. You do not need to talk or explain the exercise in the video. You will upload written cues and descriptions later. (Another planned feature will be separate audio uploads.)"
}, {
  "question": "How many exercises can I upload?",
  "answer": "As many as you want. You can upload all exercises through the trainer portal. Once they are uploaded you can use them to create all your workout classes."
}];

export const Class = `
Your Class Library is a collection of your workout classes. Classes in your library are published and are available on the app. Unpublished classes can not be seen until they are published.
`;

export const ClassFAQ = [{
  "question": "How do I add a new class I don't have in my library?",
  "answer": "Click the add class button in the top right corner of the screen. Name the class and hit submit.",
}];

export const ClassDrafts = `
Your Unpublished classes are classes that are missing content or aren't finished. Unpublished classes can not be seen until they are published.
`;

export const PlaybookTextList = [{
  "heading": "What is a Playbook?",
  "text": "A Playbook is a collection of workout classes just like a playlist is a collection of songs. Create a Playbook to allow fans and members to develop a workout schedule."
}, {
  "heading": "What can a playbook be used for?",
  "text": [
    "You can create a playbook of workouts that are similar in style. For example a core focused playbook.",
    "You can create a playbook that allows the member to progress, train, and get stronger. Maybe it could be a 6 week \"Get Ready For Summer\" Playbook.",
    "You can create a playbook to teach a member a skill. Maybe your goal is to teach a member how to do a pull up. You may create different workouts and days to build strength and work on different techniques that will help them achieve a pull up by the end of 8 weeks.",
    "It is up to you how you want to use the Playbook Feature! Create a playbook and encourage people to move and live a healthy lifestyle!"
  ]
}];

export const PlaybookFAQ = [{
  "question": "Can I put classes in multiple playbooks?",
  "answer": "Yes, but do this with intention. You don't want all your playbooks to be the same."
}];

export const TemplateTextList = [{
  "heading": "What is a Template?",
  "text": "A Template is a starting point for creating a new workout class. You can use templates when creating a class to help you be more efficient and create classes faster."
}, {
  "heading": "Why use a template?",
  "text": "Templates allow you to put placeholders where exercises would go so when you create your class you can drag and drop exercises."
}, {
  "heading": "Example",
  "text": "Let's say for a lot of the classes you create you do 3 sets of 2 exercises in each set. The exercises are always 45 seconds and the rest in between is always 15 seconds. You can create a template for that and reuse it every time you create a class."
}];

